import { hasPresentValue } from 'utils'

const isMissingNumberOfStudentsEnrolled = (courses) => {
  return !courses.every((course) => hasPresentValue(course.enrollment))
}
export default isMissingNumberOfStudentsEnrolled
